module.exports = __webpack_public_path__ + "static/media/6.50acccc7.png";